<template>
  <div v-html="styledSvgContent" class="resource-image"></div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    fileName: {
      type: String,
      required: true,
    },
    assetLocation: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '30px', 
    },
    height: {
      type: String,
      default: '30px',
    },
  },
  data() {
    return {
      svgContent: '',
    };
  },
  watch: {
    fileName(newFileName) {
      this.loadSvgIcon(newFileName);
    }
  },
  computed: {
    styledSvgContent() {
      return this.svgContent.replace(/<svg /, `<svg width="${this.width}" height="${this.height}" `);
    }
  },
  async mounted() {
    await this.loadSvgIcon(this.fileName);
  },
  methods: {
    async loadSvgIcon(fileName) {
      try {
        const response = await fetch(require(`@/assets/${this.assetLocation}/${fileName}`));
        if (!response.ok) throw new Error(`Failed to load ${fileName}`);
        this.svgContent = await response.text();
      } catch (error) {
        const fallbackResponse = await fetch(require(`@/assets/${this.assetLocation}/Forum.svg`));
        this.svgContent = await fallbackResponse.text();
      }
    },
  },
};
</script>

<style scoped>
.resource-image {
  margin-right: 10px;
  display: inline-block;
  margin-top: 4px;
}
</style>